<template>
  <div>
    <v-dialog v-model="showDialog" persistent max-width="600">

      <v-card v-show="!deleteDialog">

        <v-card-title class="title">{{title}}</v-card-title>

        <slot></slot>

        <v-card-actions>
          <v-btn v-if="showDelete" flat @click="deleteDialog=true">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="btnClicked('cancel')">Cancel</v-btn>
          <v-btn flat color="primary" @click="btnClicked('save')">Save</v-btn>
        </v-card-actions>

      </v-card>

      <v-card v-show="deleteDialog">
        <v-card-title class="title">Delete {{deleteItemDescription}}?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="deleteDialog = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="btnClicked('delete')">Delete</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'GatDialogForm',
    props: ['value','title','deleteItemDescription','showDelete'],
    components: {},
    data: function() {
      return	{
        showDialog : false,
        deleteDialog:false,
      }
    },

    created(){
      this.showDialog = this.value;
    },

    watch:{
      value(newValue){
        this.showDialog = newValue;
      }
    },

    methods:{
      btnClicked(btn){
        this.deleteDialog = false;
        this.$emit('btnClicked',btn );
      }
    },
  }
</script>

<style scoped>

</style>
